import React, { useState, useEffect } from 'react'
import { Table, Input, message, DatePicker, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import axios from 'axios'
import { toast } from 'react-toastify'
import { GetEventStudentAttendance } from '../../../AllAPI/StudentAPI'

const EventAttendanceReport = () => {
  const formDataFromStorage = JSON.parse(
    sessionStorage.getItem('studentData') || '{}',
  )
  const RegId = formDataFromStorage.reg_id
  const BoardingYear = formDataFromStorage.year
  const BranchId = formDataFromStorage.branch_id

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  // Date Filters
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)

  // Fetch API with optional dates
  const fetchAttendance = async () => {
    setLoading(true)
    if (!fromDate || !toDate) {
      toast.warning('Please select both From and To dates')
      return
    }

    const start = fromDate.format('YYYY-MM-DD')
    const end = toDate.format('YYYY-MM-DD')

    const objData = {
      fromDate: start,
      toDate: end,
      reg_id: RegId,
    }

    try {
      const res = await axios.post(
        `${GetEventStudentAttendance}/${BranchId}/${BoardingYear}`,
        objData,
      )
      if (!res.data || res.data.length === 0) {
        toast.warn('Data not available!')
        setData([])
        return
      }
      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        attendance_date: item.attendance_date || '-',
        event_name: item.event.event_name || '-',
        status:
          item.status == 1 ? 'Present' : item.status == 2 ? 'Absent' : '-',
        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load student list')
    } finally {
      setLoading(false)
    }
  }

  // Search Filter
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    const dateString = item.attendance_date
      ? new Date(item.attendance_date).toLocaleDateString('en-GB') // DD/MM/YYYY
      : ''

    const name = item.event_name?.toLowerCase() || ''

    return dateString.includes(search) || name.includes(search)
  })

  const statusStyle = (value) => {
    if (value === 'Present') {
      return {
        background: '#d4fcd4',
        border: '1px solid #30c230',
        padding: '3px 8px',
        borderRadius: '10px',
        textAlign: 'center',
      }
    }
    if (value === 'Absent') {
      return {
        background: '#ffd6d6',
        border: '1px solid #ff4d4f',
        padding: '3px 8px',
        borderRadius: '10px',
        textAlign: 'center',
      }
    }
    return {}
  }

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Event Name', dataIndex: 'event_name' },
    { title: 'Date', dataIndex: 'attendance_date' },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (value) => <span style={statusStyle(value)}>{value}</span>,
    },
  ]

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>

        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Event Attendance Report</h2>
          </div>

          {/* Search Bar */}
          <div className="">
            <div
              className="row"
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <div className="col-12 col-md-8">
                <div className="row">
                  <div className="col-12 col-md-4">
                    <DatePicker
                      placeholder="From Date"
                      className="w-100"
                      onChange={(date) => setFromDate(date)}
                    />
                  </div>
                  <div className="col-12 col-md-4">
                    <DatePicker
                      placeholder="To Date"
                      className="w-100"
                      onChange={(date) => setToDate(date)}
                    />
                  </div>
                  <div className="col-12 col-md-2">
                    <Button className="addButton" onClick={fetchAttendance}>
                      Show
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 text-end">
                <Input
                  placeholder="Search..."
                  prefix={<SearchOutlined />}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  style={{ width: 250, marginBottom: 20 }}
                />
              </div>
            </div>
          </div>

          {/* Table */}
          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>

        <div className="col-12 col-md-2"></div>
      </div>
    </div>
  )
}

export default EventAttendanceReport
